import { render, staticRenderFns } from "./jqs_chengji.vue?vue&type=template&id=1b7482fa&scoped=true"
import script from "./jqs_chengji.vue?vue&type=script&lang=js"
export * from "./jqs_chengji.vue?vue&type=script&lang=js"
import style0 from "./jqs_chengji.vue?vue&type=style&index=0&id=1b7482fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7482fa",
  null
  
)

export default component.exports